import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, selectEntities } from '../reducers/item-translations.reducer';

export const getItemTranslationState = createFeatureSelector<State>('itemTranslationState');

export const selectItemTranslationEntities = createSelector(getItemTranslationState, state => selectEntities(state));
